// ======================================================================
// File Name       : ContentHistorySearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { DATA_AFFIILIATION_TYPE } from '../../../constants/ContentConstant';
import { CONTENT_TYPE_STR } from '../../../constants/ContentHistoryConstant';
import { VALIDATE_TYPE } from '../../../constants/index';
import RenderField from '../../../utils/ReduxFormUtils';
import CustomButton from '../../button/CustomButton';

class ContentHistorySearch extends React.Component {
  render() {
    const { startPosition, recordNum, onSearchBtnClick, getStartEndData } = this.props;
    return (
      <div>
        <h3>検索する項目を指定してください</h3>
        <Col sm={12} className="padding-top-10">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              onSearchBtnClick();
            }}
            className='form-horizontal'
          >
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コンテンツ識別ID
              </Col>
              <Col sm={7}>
                <RenderField
                  label="コンテンツ識別ID"
                  type="text"
                  name="contentSecernId"
                  maxLength="64"
                  validates={[VALIDATE_TYPE.ID]}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コンテンツ名
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="contentName" maxLength="256" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
                実施期間
              </Col>
              <Col sm={3}>
                <RenderField
                  label="実施期間"
                  type="datetime"
                  name="learningEndTimeFrom"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  label="実施期間"
                  type="datetime"
                  name="learningEndTimeTo"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
            </Form.Group>
            <Col sm={12}>
              <RenderField
                name="dateTimeMinMax"
                type="dateTimeMinMax"
                validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                keyDateFrom={'learningEndTimeFrom'}
                keyDateTo={'learningEndTimeTo'}
              />
            </Col>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={12}>
                ※ 実施期間を長くすると表示に時間がかかる場合があります。
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コンテンツ種別
              </Col>
              <Col sm={7}>
                <RenderField
                  data={CONTENT_TYPE_STR}
                  name="contentType"
                  type="selectbox"
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                自サービス/外部
              </Col>
              <Col sm={9} className="padding-top-10">
                <RenderField
                  className="margin-left-30 padding-top-clear"
                  name="dataAffiliationType"
                  value={DATA_AFFIILIATION_TYPE.NOT_SELECT}
                  type="radio"
                  label="選択なし"
                  normalizeRadio
                />
                <RenderField
                  className="margin-left-30 padding-top-clear"
                  name="dataAffiliationType"
                  value={DATA_AFFIILIATION_TYPE.INTERNAL}
                  type="radio"
                  label="自サービスコンテンツ"
                  normalizeRadio
                />
                <RenderField
                  className="margin-left-30 padding-top-clear"
                  name="dataAffiliationType"
                  value={DATA_AFFIILIATION_TYPE.EXTERNAL}
                  type="radio"
                  label="外部コンテンツ"
                  normalizeRadio
                />
              </Col>
            </Form.Group>
            <Form.Group className="margin-top-20 text-center">
              <Col sm={12} className='margin-bottom-15'>
                <CustomButton
                  btnStyle="btn btn-primary btn-96"
                  text="検索"
                  type="submit"
                  iconClass="bi bi-search"
                />
              </Col>
            </Form.Group>
          </Form>
        </Col>
      </div>
    );
  }
}


export default ContentHistorySearch;
